/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * User setting DTO.
 */
export interface UserSettingDto {
  /**
   * Settings key.
   */
  key: string;
  /**
   * Value of settings key.
   */
  value: string;
}
